<template>
  <div>
    <page-toolbar>
      <exposure-toolbar :marketId="marketId" @change="onChange" @export="onExport" />
    </page-toolbar>

    <div ref="container" class="grid"></div>
  </div>
</template>

<script>
import PageToolbar from '@/components/PageToolbar'
import ExposureToolbar from '../../components/Report/ExposureToolbar2'
import lastNextTransactions from '../../dashboard-components/last-next-transactions'
import {mapGetters} from 'vuex'
import params from '../../helpers/params'

export default {
  methods: {
    onChange(e) {
      lastNextTransactions.render(kendo.jQuery(this.$refs.container), e, 'report')
    },
    onExport(e) {
      const qs = params.fromObject({
        t: this.tokenString,
        ...e,
      })
      location.href = `/api/report/LastNext/LastNextExportToExcel?${qs}`
    },
  },
  computed: {
    ...mapGetters({marketId: 'app/marketId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
  components: {
    PageToolbar,
    ExposureToolbar,
  },
}
</script>

<style scoped>
.grid {
  font-size: 0.9em;
}
</style>
